import React, { useState, useEffect, useRef, useMemo } from "react";
import { Form, Modal, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import BASE_URL from "../../../assets/global/url";
import {
  useNavigate,
  useParams,
  Link,
  useSearchParams,
} from "react-router-dom";
import swal from "sweetalert";
import { useInvoicePDF, InvoicePDFFrame } from "./InvoicePDF2";
import useDecodeToken from "../../../hooks/customHook/useDecodeToken";
import DatePicker from "react-datepicker";
import Select from "react-select";
import CustomerSelect from "../../../components/inputs/CustomerSelect";
import { selectCustomStyles } from "../../../assets/global/selectCustomStyles";
import useDarkMode from "../../../components/Themes/Usedarkmode";
import { format } from "date-fns";
import {
  currencyList,
  formatToTwoDecimal,
  getCurrencySymbol,
  parseNumber,
} from "../../../utils/numberFormatter";
import { checkDrNumber } from "../../../services/DrSalesValidator";
import { showDeficitAlert } from "../../../utils/showDeficitAlert";
import NumberInDecimals from "../../../components/inputs/NumberFormatted";
import { warnIfNoCutoff } from "../../../utils/cutoffDateValidation";
import TypedDateInput, {
  DATE_DISPLAY_FORMAT,
  DATE_PICKER_FORMATS,
} from "../../../components/inputs/TypedDateInput";

const getCustomerLabel = (customer) =>
  customer.company_name?.trim() ||
  [customer.first_name?.trim(), customer.last_name?.trim()]
    .filter(Boolean)
    .join(" ");

// Invoice Date / Due Date use TypedDateInput (typed as MM/dd/yyyy, shown as
// Oct/08/2026), same as create_invoice.jsx.

const UpdateInvoice = ({ authrztn }) => {
  const { themeSelectStyles } = useDarkMode();
  const drInputRef = useRef(null);
  const userLoggedID = useDecodeToken();
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [validated, setValidated] = useState(false);
  const [invoiceStatus, setInvoiceStatus] = useState("");
  const [customerData, setCustomerData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [cutOffData, setCutOffData] = useState([]);
  const [warehouseData, setWarehouseData] = useState([]);
  const [subject3Data, setSubject3Data] = useState([]);

  const [selectedInvoiceDate, setSelectedInvoiceDate] = useState("");
  const [isCutoffPosted, setIsCutoffPosted] = useState(false);
  const [isCutoffExists, setIsCutoffExists] = useState(true); // Add this new state
  const [isAdded, setIsAdded] = useState(false);

  const [currencyRate, setCurrencyRate] = useState("");
  const [transactionDiscountModal, setTransactionDiscountModal] =
    useState(false);
  const [edit, setEdit] = useState(false);

  const [shippingFeeModal, setShippingFeeModal] = useState(false);
  const [displayDiscount, setDisplayDiscount] = useState(0);
  const [displayShippingFee, setDisplayShippingFee] = useState(0);
  const [inputDiscount, setInputDiscount] = useState("");
  const [inputShippingFee, setInputShippingFee] = useState("");
  const [weighingFeeModal, setWeighingFeeModal] = useState(false);
  const [otherFeeModal, setOtherFeeModal] = useState(false);
  const [displayWeighingFee, setDisplayWeighingFee] = useState(0);
  const [displayOtherFee, setDisplayOtherFee] = useState(0);
  const [inputWeighingFee, setInputWeighingFee] = useState("");
  const [inputOtherFee, setInputOtherFee] = useState("");
  const [otherFees, setOtherFees] = useState([]);
  const [totalFees, setTotalFees] = useState(0);
  const OTHER_FEE_PAGE_SIZE = 5;
  const [otherFeePage, setOtherFeePage] = useState(0);
  const [modalDiscount, setModalDiscount] = useState(true);
  const [modalDiscountType, setModalDiscountType] = useState("");
  const [modalDiscountValue, setModalDiscountValue] = useState("");
  const [editableCurrencyRate, setEditableCurrencyRate] =
    useState(currencyRate);
  const [print, setPrint] = useState(false);
  // Generated once each time the PDF modal opens, shared by viewer and download
  const invoicePdf = useInvoicePDF(id, print);
  const [isApproving, setIsApproving] = useState(false);

  const handleCloseTransactionDiscount = () =>
    setTransactionDiscountModal(false);
  const handleCloseWeighingFee = () => setWeighingFeeModal(false);
  const handleCloseOtherFee = () => setOtherFeeModal(false);
  const handleCloseShippingFee = () => setShippingFeeModal(false);
  const handleShowShippingFee = () => setShippingFeeModal(true);

  const [editIndex, setEditIndex] = useState(null);
  const [transactionId, setTransactionId] = useState("");
  const [clientTransactionId, setClientTransactionId] = useState("");
  const [selectedWarehouse, setSelectedWarehouse] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedMethod, setSelectedMethod] = useState("");
  const [selectedDueDate, setSelectedDueDate] = useState("");
  // Set when a Due Date is rejected (same as / earlier than the Invoice Date) so
  // Update stays blocked until a valid Due Date is chosen.
  const [dueDateError, setDueDateError] = useState("");
  const [inputPaymentTerms, setInputPaymentTerms] = useState("");
  const [selectedDestination, setSelectedDestination] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [remarks, setRemarks] = useState("");
  const [drNumber, setDrNumber] = useState("");
  const [originalDrNumber, setOriginalDrNumber] = useState("");
  const [drNumberEnabled, setDrNumberEnabled] = useState(false);
  const [poNumber, setPoNumber] = useState("");
  const [containerNumber, setContainerNumber] = useState("");
  const [pier, setPier] = useState("");
  const [selectedSubject3, setSelectedSubject3] = useState("");
  const [shipmentFee, setShipmentFee] = useState("");
  const [vatPercent, setVatPercent] = useState(0);
  const [preVatBase, setPreVatBase] = useState(0);
  const [taxSettings, setTaxSettings] = useState([]);
  const [selectedTaxId, setSelectedTaxId] = useState("");
  const [selectedTaxRate, setSelectedTaxRate] = useState(0);
  const [inputQuantities, setInputQuantities] = useState({});
  const [unitPriceInputs, setUnitPriceInputs] = useState({}); // keyed by index, holds raw typing value
  const [isSpecialTax, setIsSpecialTax] = useState(false);
  const [backupVatPercent, setBackupVatPercent] = useState("");
  const [backupTaxId, setBackupTaxId] = useState("");
  const [backupTaxRate, setBackupTaxRate] = useState(0);
  const [items, setItems] = useState([
    {
      productId: "",
      productCode: "",
      productName: "",
      remaining: "",
      averagePrice: "",
      quantity: "",
      moisture: "",
      netWeight: "",
      unitPrice: "",
      sales_profit: "",
      discount: "",
      subtotal: 0,
      discountType: "percentage",
    },
  ]);
  const [totalItemDiscount, setTotalItemDiscount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalMoisture, setTotalMoisture] = useState(0);
  const [totalNetWeight, setTotalNetWeight] = useState(0);
  const [totalWeightedAmount, setTotalWeightedAmount] = useState(0);
  const [totalMoistureAmount, setTotalMoistureAmount] = useState(0);
  const [totalNetWeightAmount, setTotalNetWeightAmount] = useState(0);
  const [amount, setAmount] = useState(0);
  const [qty, setQty] = useState(0);
  const [isAmountQtyDisabled, setIsAmountQtyDisabled] = useState(true);
  const discountAmountPhp = useRef(0);
  const totalAmountUseRef = useRef(0);
  const currencySymbol = getCurrencySymbol(currencyData, selectedCurrency);

  const handleShowTransactionDiscount = () => {
    if ((parseFloat(totalAmountUseRef.current) || 0) <= 0) {
      swal({
        icon: "error",
        title: "No Products Added",
        text: "Please add at least one product with a valid quantity before adding a discount.",
      });
      return;
    }
    setTransactionDiscountModal(true);
  };

  const handleShowWeighingFee = () => {
    if ((parseFloat(totalAmountUseRef.current) || 0) <= 0) {
      swal({
        icon: "error",
        title: "No Products Added",
        text: "Please add at least one product with a valid quantity before adding a weighing fee.",
      });
      return;
    }
    setWeighingFeeModal(true);
  };

  const handleShowOtherFee = () => {
    if ((parseFloat(totalAmountUseRef.current) || 0) <= 0) {
      swal({
        icon: "error",
        title: "No Products Added",
        text: "Please add at least one product with a valid quantity before adding other fees.",
      });
      return;
    }
    setOtherFeeModal(true);
  };

  const fetchSpecificInvoice = () => {
    axios
      .get(`${BASE_URL}/invoice/getSpecificInvoice`, {
        params: { id: id },
      })
      .then((res) => {
        if (res.data) {
          const {
            data: SalesInvoiceData,
            result: ProductTagInvoice,
            isPosted,
            cutoffExists,
            other_fees_list = [],
          } = res.data;
          setTransactionId(SalesInvoiceData.transaction_id);
          setClientTransactionId(SalesInvoiceData.client_transaction_id);
          setSelectedWarehouse(SalesInvoiceData.warehouse_id);
          const c = SalesInvoiceData.customer;
          setSelectedCustomer({
            value: SalesInvoiceData.customer_id,
            label: getCustomerLabel(c),
          });
          setSelectedMethod(SalesInvoiceData.payment_method);
          setSelectedDueDate(SalesInvoiceData.due_date);
          setDueDateError("");
          setSelectedInvoiceDate(SalesInvoiceData.invoice_date);
          setInputPaymentTerms(SalesInvoiceData.payment_terms);
          setRemarks(SalesInvoiceData.remarks);
          // setDrNumber(SalesInvoiceData.dr_number);
          setDrNumber(SalesInvoiceData.dr_number || "");
          setOriginalDrNumber(SalesInvoiceData.dr_number || "");
          setDrNumberEnabled(!!SalesInvoiceData.dr_number);
          setPoNumber(SalesInvoiceData.po_number);
          setContainerNumber(SalesInvoiceData.container_number);
          setPier(SalesInvoiceData.pier);
          setSelectedDestination(SalesInvoiceData.destination);
          setSelectedCurrency(SalesInvoiceData.currency_id);
          setTotalAmount(SalesInvoiceData.total_amount);
          // Store the initial total amount for reference
          totalAmountUseRef.current = SalesInvoiceData.total_amount;
          setTotalItemDiscount(SalesInvoiceData.item_discount);
          setDisplayShippingFee(SalesInvoiceData.shipping_fee);
          setDisplayDiscount(SalesInvoiceData.transaction_discount);
          // setInputDiscount(SalesInvoiceData.transaction_discount);
          setInvoiceStatus(SalesInvoiceData.status);
          setModalDiscountType(SalesInvoiceData.discount_type);
          setIsCutoffPosted(isPosted);
          setIsCutoffExists(cutoffExists);
          setIsAdded(!!SalesInvoiceData.payAdded);
          setCurrencyRate(SalesInvoiceData.rate);
          setSelectedSubject3(SalesInvoiceData.account_list_sub3_id);
          setShipmentFee(SalesInvoiceData.liability_amount);
          setAmount(SalesInvoiceData.amount);
          setQty(SalesInvoiceData.quantity);
          // setCurrencyRate(SalesInvoiceData.rate);
          setEditableCurrencyRate(SalesInvoiceData.rate);
          setVatPercent(parseFloat(SalesInvoiceData.vat_percent) || 0);
          setSelectedTaxId(SalesInvoiceData.tax_id || "");
          setSelectedTaxRate(parseFloat(SalesInvoiceData.tax_rate) || 0);

          const wFee = parseNumber(SalesInvoiceData.weighing_fee) || 0;
          setDisplayWeighingFee(wFee);
          setInputWeighingFee(wFee > 0 ? String(wFee) : "");

          const oFee = parseNumber(SalesInvoiceData.other_fee) || 0;
          setDisplayOtherFee(oFee);
          setInputOtherFee(oFee > 0 ? String(oFee) : "");

          setIsSpecialTax(SalesInvoiceData.isSpecialTax);

          // Load named other fees from the child table (returned as other_fees_list)
          if (Array.isArray(other_fees_list) && other_fees_list.length > 0) {
            setOtherFees(other_fees_list);
          }

          const transformedItems = ProductTagInvoice.map((item) => ({
            stock_management_id: item.stock_management_id,
            productId: item.product_id,
            productCode: item.product_code,
            productName: { value: item.product_id, label: item.product_name },
            // item.product_id.toString(),
            remaining: item.remaining,
            averagePrice: item.average_price,
            unitPrice: item.unit_price,
            quantity: item.quantity,
            moisture: item.moisture ?? 0,
            netWeight: item.net_weight ?? 0,
            discount: item.discount_item,
            subtotal: item.subtotal,
            discountType: item.discount_type,
            sales_profit: item.sales_profit,
          }));

          console.log(transformedItems);

          setItems(transformedItems);
          const initialQuantities = {};
          transformedItems.forEach((item, index) => {
            initialQuantities[index] = item.quantity > 0 ? item.quantity : "";
          });
          setInputQuantities(initialQuantities);

          if (SalesInvoiceData.discount_type === "percentage") {
            const subtotalSum = transformedItems.reduce((total, value) => {
              return total + value.subtotal;
            }, 0);
            const newDiscount =
              (SalesInvoiceData.transaction_discount / 100) * subtotalSum;
            discountAmountPhp.current = newDiscount;
          } else {
            discountAmountPhp.current = SalesInvoiceData.transaction_discount;
          }
          calculateTotals(
            transformedItems,
            true,
            parseFloat(SalesInvoiceData.vat_percent) || 0,
            parseFloat(SalesInvoiceData.tax_rate) || 0,
            parseFloat(SalesInvoiceData.weighing_fee) || 0,
            parseFloat(SalesInvoiceData.other_fee) || 0,
            other_fees_list,
            SalesInvoiceData.transaction_discount || 0,
            SalesInvoiceData.discount_type || "fixed",
          );
        }
      })
      .catch((err) => console.log(err));
  };

  const fetchDataProduct = async (warehouse_id) => {
    try {
      if (!warehouse_id) {
        setProductData([]);
        return;
      }

      const [productRes] = await Promise.all([
        axios.get(
          `${BASE_URL}/invoice/getProductInventoryInvoice?warehouse_id=${warehouse_id}`,
        ),
      ]);

      setProductData(productRes.data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchDrNumberCode = async () => {
    try {
      const res = await axios.get(BASE_URL + "/invoice/getDrNumberCode");
      setDrNumber(res.data);
    } catch (err) {
      console.error("Error fetching DR Number:", err);
      swal({
        icon: "error",
        title: "Error",
        text: "Failed to generate DR Number.",
      });
    }
  };

  const fetchCustomerCurrency = async () => {
    try {
      const [currencyRes, customerRes] = await Promise.all([
        axios.get(`${BASE_URL}/currency/fetchCurrency`),
        axios.get(`${BASE_URL}/invoice/getCustomersData`),
      ]);

      setCurrencyData(currencyRes.data);

      const sortedCustomerList = customerRes.data.sort(
        (a, b) => b.customer_id - a.customer_id,
      );
      setCustomerData(sortedCustomerList);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCutOff = () => {
    axios
      .get(BASE_URL + "/invoice/getCutoffPosted")
      .then((res) => {
        setCutOffData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchWarehouse = () => {
    axios
      .get(BASE_URL + "/invoice/getWarehouse")
      .then((res) => {
        setWarehouseData(res.data);
      })
      .catch((err) => console.log(err));
  };

  const fetchLiabilitySub3 = () => {
    axios
      .get(BASE_URL + "/invoice/getSubject3", {
        params: {
          selectedCurrency,
        },
      })
      .then((res) => {
        setSubject3Data(res.data);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      });
  };

  const fetchActiveSalesTaxes = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/invoice/getActiveSalesTax`);
      setTaxSettings(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDataProduct();
    fetchCustomerCurrency();
    fetchWarehouse();
    fetchCutOff();
    fetchActiveSalesTaxes();
  }, []);

  useEffect(() => {
    if (selectedWarehouse) {
      fetchDataProduct(selectedWarehouse);
    }
  }, [selectedWarehouse]);

  useEffect(() => {
    if (selectedCurrency) {
      fetchLiabilitySub3();
    }
  }, [selectedCurrency]);

  useEffect(() => {
    fetchSpecificInvoice();
  }, [id]);

  useEffect(() => {
    const total = otherFees.reduce(
      (sum, fee) => sum + (parseFloat(fee.feeAmount) || 0),
      0,
    );
    setTotalFees(total);
    calculateTotals(
      items,
      false,
      vatPercent,
      selectedTaxRate,
      displayWeighingFee,
      displayOtherFee,
      otherFees,
      displayDiscount,
      modalDiscountType,
      isSpecialTax,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otherFees]);

  const addNewItem = () => {
    setItems([
      ...items,
      {
        productCode: "",
        productName: "",
        remaining: "",
        averagePrice: "",
        quantity: "",
        moisture: "",
        netWeight: "",
        unitPrice: "",
        sales_profit: "",
        discount: "",
        subtotal: 0,
        discountType: "percentage",
      },
    ]);
  };

  const scrollPageToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth",
    });
  };

  const scrollPageToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const isProductSelected = (productId, items, currentIndex) => {
    return items.some(
      (item, index) =>
        index !== currentIndex && item.productName === productId.toString(),
    );
  };

  const getFilteredProductData = (index) => {
    return productData;
  };

  // Unit Price shown when a product is picked: 2 decimals unless the 3rd or 4th
  // decimal has a value, then all 4.
  // 80 -> 80.00, 80.5 -> 80.50, 80.0001 -> 80.0001, 80.123 -> 80.1230, 0 -> 0.00
  const formatUnitPriceDisplay = (value) => {
    const fixed = Number(value).toFixed(4);
    if (!Number.isFinite(Number(fixed)) || Number(fixed) === 0) return "0.0000";

    return fixed.endsWith("00") ? fixed.slice(0, -2) : fixed;
  };

  const handleProductChange = (index, selectedOption, items, setItems) => {
    const selectedProduct = productData.find(
      (product) => product.product_id.toString() === selectedOption?.value,
    );

    if (selectedProduct) {
      console.log("Selected Product:", selectedProduct.product_id);
      const updatedItems = [...items];

      updatedItems[index] = {
        ...updatedItems[index],
        productId: selectedProduct.product_id,
        productCode: selectedProduct.product_code,
        productName: selectedOption,
        remaining: selectedProduct.total_stock,
        averagePrice: Number(selectedProduct.average_price || 0).toFixed(4),
        unitPrice: formatUnitPriceDisplay(selectedProduct.average_price),
        stockDetails: selectedProduct.stock_details,
        moisture: 0,
        netWeight: 0,
        subtotal: 0,
      };

      setInputQuantities((prev) => ({
        ...prev,
        [index]: 0,
      }));

      setItems(updatedItems);
    } else {
      console.log("Selected product not found in productData");
      const updatedItems = [...items];
      updatedItems[index] = {
        ...updatedItems[index],
        productName: "",
      };
      setItems(updatedItems);
    }

    if (selectedProduct.total_stock === 0) {
      swal({
        icon: "warning",
        title: "Out of Stock",
        text: "The remaining quantity of this product is zero.",
      });
    }
  };

  const removeComma = (n) => {
    return parseFloat(String(n).replace(/,/g, ""));
  };

  // console.log(items);

  const shipmentAmount = (value, field) => {
    const newNumericValue = parseNumber(value) || 0;

    if (field === "amount") {
      setAmount(value);

      const currentQty = parseNumber(qty) || 0;
      setShipmentFee(newNumericValue * currentQty);
    } else if (field === "qty") {
      setQty(value);

      const currentAmount = parseNumber(amount) || 0;
      setShipmentFee(newNumericValue * currentAmount);
    }
  };

  const addNewFee = () => {
    const newFees = [...otherFees, { feeName: "", feeAmount: "" }];
    setOtherFees(newFees);
    setOtherFeePage(Math.floor((newFees.length - 1) / OTHER_FEE_PAGE_SIZE));
  };

  const handleFeeChange = (index, field, value) => {
    const newOtherFees = otherFees.map((fee, i) =>
      i === index ? { ...fee, [field]: value } : fee,
    );
    setOtherFees(newOtherFees);
  };

  const removeFee = (index) => {
    const newOtherFees = otherFees.filter((_, i) => i !== index);
    setOtherFees(newOtherFees);
    const newTotalPages = Math.ceil(newOtherFees.length / OTHER_FEE_PAGE_SIZE);
    if (otherFeePage >= newTotalPages && otherFeePage > 0) {
      setOtherFeePage((p) => p - 1);
    }
  };

  const handleCurrencyRateChange = (e) => {
    let inputValue = e.target.value.replace(/[^0-9.]/g, "");
    if ((inputValue.match(/\./g) || []).length > 1) return;
    let [integerPart, decimalPart] = inputValue.split(".");
    if (integerPart) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    let formattedValue =
      decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

    setCurrencyRate(formattedValue);
  };

  const handleTransactionDiscount = (e) => {
    let inputValue = e.target.value.replace(/[^0-9.,]/g, "");

    if ((inputValue.match(/\./g) || []).length > 1) {
      return;
    }

    let [integerPart, decimalPart] = inputValue.split(".");

    if (integerPart) {
      integerPart = integerPart.replace(/,/g, "");
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    let formattedValue =
      decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;
    setInputDiscount(formattedValue);
  };

  const handleInputQTY = (index, field, value) => {
    let inputValue = String(value).replace(/[^0-9.]/g, "");

    let [integerPart, decimalPart] = inputValue.split(".");

    if (integerPart) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    let formattedValue =
      decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

    const cleanedValue = formattedValue.replace(/^0+,|^0+/, ""); // Remove leading zeros and comma

    const updatedItems = [...items];

    if (field === "quantity") {
      setInputQuantities((prev) => ({
        ...prev,
        [index]:
          parseFloat(formattedValue) === 0
            ? ""
            : value.length > 1 && !value.includes(".")
              ? cleanedValue
              : formattedValue,
      }));

      const originalQuantity = parseFloat(updatedItems[index].quantity) || 0;
      const remainingQuantity = parseFloat(updatedItems[index].remaining) || 0;
      const inputQuantity =
        parseFloat(String(formattedValue).replace(/,/g, "")) || 0;

      // if (inputQuantity > originalQuantity + remainingQuantity) {
      //   swal(
      //     "Insufficient stock!",
      //     "The requested quantity exceeds available stock.",
      //     "error",
      //   );
      //   setInputQuantities((prev) => ({
      //     ...prev,
      //     [index]: "",
      //   }));
      //   return;
      // } else {
      //   updatedItems[index].quantity = inputQuantity;
      // }
      updatedItems[index].quantity = inputQuantity;
    } else {
      updatedItems[index][field] =
        value.length > 1 && !value.includes(".")
          ? cleanedValue
          : formattedValue;
    }

    const quantity =
      parseFloat(String(updatedItems[index].quantity).replace(/,/g, "")) || 0;
    let moisture =
      parseFloat(String(updatedItems[index].moisture).replace(/,/g, "")) || 0;
    const unitPrice =
      parseFloat(String(updatedItems[index].unitPrice).replace(/,/g, "")) || 0;
    let netWeight =
      parseFloat(String(updatedItems[index].netWeight).replace(/,/g, "")) || 0;

    if (field === "moisture") {
      // Validation for not exceeding 100%
      if (
        parseFloat(String(updatedItems[index].moisture).replace(/,/g, "")) > 100
      ) {
        swal({
          icon: "error",
          title: "Invalid Moisture",
          text: "Moisture cannot exceed 100%.",
        });
        updatedItems[index].moisture = "0";
        moisture = 0;
      }
    }

    if (field !== "netWeight") {
      netWeight = Math.round(quantity * (1 - moisture / 100));
      const [integer, decimal] = String(netWeight).split(".");
      updatedItems[index].netWeight =
        integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        (decimal ? "." + decimal : "");
    }

    let subtotal = netWeight * unitPrice; // This will be 0 if unitPrice is 0, which is now allowed

    let discount =
      parseFloat(String(updatedItems[index].discount).replace(/,/g, "")) || 0;

    if (field === "discount") {
      if (updatedItems[index].discountType === "percentage") {
        if (discount > 100) {
          swal({
            icon: "error",
            title: "Invalid Discount",
            text: "Percentage discount cannot exceed 100%.",
          });
          updatedItems[index].discount = "0";
          discount = 0;
        }
      } else {
        // Don't allow discount to exceed subtotal
        if (discount > subtotal) {
          swal({
            icon: "error",
            title: "Invalid Discount",
            text: "The discount should not exceed the subtotal.",
          });
          updatedItems[index].discount = "0";
          discount = 0;
        }
      }
    }

    // Calculate effective discount
    let effectiveDiscount = 0;
    if (updatedItems[index].discountType === "percentage") {
      effectiveDiscount = (discount / 100) * subtotal;
    } else {
      effectiveDiscount = discount;
    }

    updatedItems[index].subtotal = subtotal - effectiveDiscount;

    setItems(updatedItems);

    calculateTotals(
      updatedItems,
      false,
      vatPercent,
      selectedTaxRate,
      displayWeighingFee,
      displayOtherFee,
      otherFees,
      displayDiscount,
      modalDiscountType,
    );
  };

  const calculateTotals = (
    items,
    isInitialLoad = false,
    currentVatPercent = vatPercent,
    currentTaxRate = selectedTaxRate,
    currentWeighingFee = displayWeighingFee,
    currentOtherFee = displayOtherFee,
    currentOtherFees = otherFees,
    currentDisplayDiscount = displayDiscount,
    currentModalDiscountType = modalDiscountType,
    currentIsSpecialTax = isSpecialTax,
  ) => {
    let totalDiscount = 0;
    let totalAmount = 0;
    let totalQty = 0;
    let totalMoist = 0;
    let totalNetW = 0;
    let totalWeightedAmt = 0;
    let totalMoistureAmt = 0;
    let totalNetWeightAmt = 0;

    items.forEach((item) => {
      const quantity = parseFloat(String(item.quantity).replace(/,/g, "")) || 0;
      const unitPrice =
        parseFloat(String(item.unitPrice).replace(/,/g, "")) || 0;
      const moisture = parseFloat(String(item.moisture).replace(/,/g, "")) || 0;
      const netWeight =
        parseFloat(String(item.netWeight).replace(/,/g, "")) || 0;
      let discount = parseFloat(String(item.discount).replace(/,/g, "")) || 0;

      let subtotal = netWeight * unitPrice;

      if (item.discountType === "percentage") {
        discount = Math.round((discount / 100) * subtotal);
      }

      if (!isNaN(discount)) {
        if (discount > subtotal) discount = 0;
        subtotal -= discount;
      }

      totalDiscount += discount;
      totalAmount += parseFloat(item.subtotal);
      totalQty += quantity;
      totalMoist += Math.round(quantity * (moisture / 100));
      totalNetW += netWeight;
      totalWeightedAmt += quantity * unitPrice;
      totalMoistureAmt += Math.round(((quantity * moisture) / 100) * unitPrice);
      totalNetWeightAmt += netWeight * unitPrice;
    });

    setTotalItemDiscount(totalDiscount);
    setTotalQuantity(totalQty);
    setTotalMoisture(totalMoist);
    setTotalNetWeight(totalNetW);
    setTotalWeightedAmount(totalWeightedAmt);
    setTotalMoistureAmount(totalMoistureAmt);
    setTotalNetWeightAmount(totalNetWeightAmt);

    // Raw product total (used for discount modal validation)
    totalAmountUseRef.current = totalAmount;

    // Transaction discount — always use passed-in values, never stale state
    let discountAmount = 0;
    if (currentDisplayDiscount > 0) {
      if (currentModalDiscountType === "percentage") {
        discountAmount = parseFloat(
          (currentDisplayDiscount / 100) * totalAmount,
        );
      } else {
        discountAmount = parseFloat(currentDisplayDiscount);
      }
    }
    discountAmountPhp.current = parseFloat(discountAmount.toFixed(2));

    // Gross Amount — VAT & Withholding Tax base (products only)
    const baseAmount = totalAmount - discountAmount;
    setPreVatBase(baseAmount);

    if (!isInitialLoad) {
      // const vat = parseFloat(currentVatPercent) || 0;
      const vat = currentIsSpecialTax ? 0 : parseFloat(currentVatPercent) || 0;
      const vatAmount = vat > 0 ? (vat / 100) * baseAmount : 0;

      // const tRate = parseFloat(currentTaxRate) || 0;
      const tRate = currentIsSpecialTax ? 0 : parseFloat(currentTaxRate) || 0;
      const taxAmount = tRate > 0 ? (tRate / 100) * baseAmount : 0;

      // Non-taxable fees added last
      const wFee = parseFloat(currentWeighingFee) || 0;
      const oFee = parseFloat(currentOtherFee) || 0;
      const namedFees = (currentOtherFees || []).reduce(
        (sum, fee) => sum + (parseFloat(fee.feeAmount) || 0),
        0,
      );

      // Special tax (Gross Amount * 0.1088)
      const specialTaxAmount = currentIsSpecialTax ? baseAmount * 0.1088 : 0;

      const finalTotal =
        baseAmount +
        vatAmount -
        taxAmount +
        specialTaxAmount -
        wFee -
        oFee -
        namedFees;
      setTotalAmount(finalTotal);
    }
  };

  const handleDiscountButton = (index) => {
    const updatedItems = [...items];
    const currentDiscountType = updatedItems[index].discountType;

    updatedItems[index].discountType =
      currentDiscountType === "percentage" ? "fixed" : "percentage";

    if (isNaN(currentDiscountType)) {
      updatedItems[index].discount = "";
    } else if (currentDiscountType === "percentage") {
      updatedItems[index].discount = (
        parseFloat(updatedItems[index].discount) * 100
      ).toFixed(2);
    } else {
      updatedItems[index].discount = (
        parseFloat(updatedItems[index].discount) / 100
      ).toFixed(2);
    }

    setItems(updatedItems);
  };

  const removeItem = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    setItems(updatedItems);
    calculateTotals(
      updatedItems,
      false,
      vatPercent,
      selectedTaxRate,
      displayWeighingFee,
      displayOtherFee,
      otherFees,
      displayDiscount,
      modalDiscountType,
    );
  };

  //for modal section
  const handleDiscountIcon = () => {
    setModalDiscount(!modalDiscount);
    setModalDiscountType(!modalDiscount ? "percentage" : "fixed");
  };

  const handleAddDiscount = () => {
    const discountValue = inputDiscount.replace(/,/g, "");
    const discount = parseFloat(discountValue) || 0;
    const discountType = modalDiscountType;
    const currentTotalAmount = parseFloat(totalAmountUseRef.current) || 0;

    if (discountType === "percentage") {
      if (discount > 100) {
        swal({
          icon: "error",
          title: "Invalid Discount",
          text: "Percentage discount cannot exceed 100%.",
        });
        setInputDiscount("0");
        return;
      }
    } else {
      if (discount > currentTotalAmount) {
        swal({
          icon: "error",
          title: "Invalid Discount",
          text: "Transaction discount should not exceed the total amount.",
        });
        setInputDiscount("0");
        return;
      }
    }

    const newDisplayDiscount = parseFloat(discountValue) || 0;
    setDisplayDiscount(newDisplayDiscount);
    calculateTotals(
      items,
      false,
      vatPercent,
      selectedTaxRate,
      displayWeighingFee,
      displayOtherFee,
      otherFees,
      newDisplayDiscount,
      modalDiscountType,
    );
    setTransactionDiscountModal(false);
  };

  const handleRemoveDiscount = (e) => {
    e.stopPropagation();
    setDisplayDiscount(0);
    setInputDiscount("");
    calculateTotals(
      items,
      false,
      vatPercent,
      selectedTaxRate,
      displayWeighingFee,
      displayOtherFee,
      otherFees,
      0,
      modalDiscountType,
    );
  };

  const handleAddShippingFee = () => {
    const shippingFee = parseFloat(inputShippingFee.replace(/,/g, "")) || 0;
    const currentTotalAmount = parseFloat(totalAmount) || 0;

    const newTotalAmount = currentTotalAmount + shippingFee;
    setTotalAmount(newTotalAmount);
    setDisplayShippingFee(inputShippingFee.replace(/,/g, ""));
    setShippingFeeModal(false);
  };

  // --- Weighing Fee ---
  const handleAddWeighingFee = () => {
    const fee = parseFloat(inputWeighingFee.replace(/,/g, "")) || 0;
    setDisplayWeighingFee(fee);
    calculateTotals(
      items,
      false,
      vatPercent,
      selectedTaxRate,
      fee,
      displayOtherFee,
      otherFees,
      displayDiscount,
      modalDiscountType,
    );
    setWeighingFeeModal(false);
  };

  const handleWeighingFeeChange = (value) => {
    setInputWeighingFee(value);
    const fee = parseNumber(value) || 0;
    setDisplayWeighingFee(fee);

    calculateTotals(
      items,
      false,
      vatPercent,
      selectedTaxRate,
      fee,
      displayOtherFee,
      otherFees,
      displayDiscount,
      modalDiscountType,
      isSpecialTax,
    );
  };

  const handleRemoveWeighingFee = (e) => {
    e.stopPropagation();
    setDisplayWeighingFee(0);
    setInputWeighingFee("");
    calculateTotals(
      items,
      false,
      vatPercent,
      selectedTaxRate,
      0,
      displayOtherFee,
      otherFees,
      displayDiscount,
      modalDiscountType,
    );
  };

  // --- Other Fee ---
  const handleAddOtherFee = () => {
    const fee = parseFloat(inputOtherFee.replace(/,/g, "")) || 0;
    setDisplayOtherFee(fee);
    calculateTotals(
      items,
      false,
      vatPercent,
      selectedTaxRate,
      displayWeighingFee,
      fee,
      otherFees,
      displayDiscount,
      modalDiscountType,
    );
    setOtherFeeModal(false);
  };

  const handleOtherFeeChange = (value) => {
    setInputOtherFee(value);
    const fee = parseNumber(value) || 0;
    setDisplayOtherFee(fee);

    calculateTotals(
      items,
      false,
      vatPercent,
      selectedTaxRate,
      displayWeighingFee,
      fee,
      otherFees,
      displayDiscount,
      modalDiscountType,
      isSpecialTax,
    );
  };

  const handleRemoveOtherFee = (e) => {
    e.stopPropagation();
    setDisplayOtherFee(0);
    setInputOtherFee("");
    calculateTotals(
      items,
      false,
      vatPercent,
      selectedTaxRate,
      displayWeighingFee,
      0,
      otherFees,
      displayDiscount,
      modalDiscountType,
    );
  };

  const validateDueDateGreaterThanInvoiceDate = (dueDate, invoiceDate) => {
    if (!dueDate || !invoiceDate) return true;

    const due = new Date(dueDate);
    const invoice = new Date(invoiceDate);

    if (due <= invoice) {
      swal({
        icon: "error",
        title: "Invalid Due Date",
        text: "Due Date must be greater than Invoice Date",
      }).then(() => {
        setSelectedDueDate("");
        // Keep the rejection so Update stays blocked until a valid Due Date is chosen.
        setDueDateError("Due Date must be greater than Invoice Date.");
      });
      return false;
    }
    return true;
  };

  const handleDueDateChange = (date) => {
    if (validateDueDateGreaterThanInvoiceDate(date, selectedInvoiceDate)) {
      setSelectedDueDate(date);
      setDueDateError("");
      warnIfNoCutoff(date, "Due Date");
    }
  };

  const handleDueInvoiceDate = (date) => {
    // Invoice Date is required: ignore the "cleared" event fired when the typed
    // text is emptied, so Approve/Reject can't go out with an empty date. The
    // field snaps back to the current date on blur.
    if (!date) return;
    const invoiceDate = date;
    setSelectedInvoiceDate(invoiceDate);
    if (invoiceDate) {
      // dateValidation(date, setSelectedInvoiceDate, "Invoice Date");
      warnIfNoCutoff(date, "Invoice Date");
    }

    // Check if the invoice date is within any cutoff range
    const isWithinCutoff = cutOffData.some((cutoff) => {
      const fromDate = new Date(cutoff.from);
      const toDate = new Date(cutoff.to);
      const selectedDate = new Date(invoiceDate);

      return selectedDate >= fromDate && selectedDate <= toDate;
    });

    if (isWithinCutoff) {
      swal({
        icon: "warning",
        title: "Invoice Date Conflict",
        text: "The invoice date you selected is already posted in the cutoff period!",
        confirmButtonColor: "#d33",
      }).then(() => {
        setSelectedInvoiceDate("");
      });
    }
  };
  console.log(items);

  // Due Date check run when Update is clicked. Returns the message to show, or an
  // empty string when the Due Date is fine:
  //  - a Due Date that was rejected while typing/selecting (the field was cleared
  //    and the message is still pending in dueDateError), or
  //  - a selected Due Date that is earlier than the Invoice Date.
  const getDueDateProblem = () => {
    if (dueDateError) return dueDateError;
    if (!selectedDueDate || !selectedInvoiceDate) return "";

    const due = new Date(selectedDueDate);
    const invoice = new Date(selectedInvoiceDate);
    if (Number.isNaN(due.getTime()) || Number.isNaN(invoice.getTime())) {
      return "";
    }

    due.setHours(0, 0, 0, 0);
    invoice.setHours(0, 0, 0, 0);
    if (due < invoice) {
      return `Due date cannot be earlier than the invoice date (${format(invoice, DATE_DISPLAY_FORMAT)}).`;
    }
    return "";
  };

  const updateInvoice = async (e) => {
    e.preventDefault();
    if (isTextDrValidationVisible === true) {
      swal({
        icon: "error",
        title: "DR number Already Exist",
        text: "Please enter a valid DR number.",
      });

      // 🎯 focus the input
      drInputRef.current?.focus();

      return; // ⛔ stop everything here
    }

    setValidated(true); // ← move to top, always set first
    // STOP if the Due Date is invalid (e.g. earlier than the Invoice Date)
    const dueDateProblem = getDueDateProblem();
    if (dueDateProblem) {
      swal({
        icon: "error",
        title: "Invalid Due Date",
        text: dueDateProblem,
      });
      return; // do not update
    }
    const form = e.currentTarget;
    // ADDED: manually check if any row with no product name exists but has qty
    const hasEmptyProductName = items.some(
      (
        item,
        index, // ← add index
      ) => !item.productName && (inputQuantities[index] || item.quantity), // ← use index
    );
    const hasMissingQty = items.some(
      (item, index) =>
        item.productName &&
        item.productName.value &&
        parseFloat(inputQuantities[index]) <= 0,
    );

    if (hasMissingQty) {
      swal({
        icon: "error",
        title: "Fields are required",
        text: "Please fill in the qty field.",
      });
      return;
    }
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      swal({
        icon: "error",
        title: "Fields are required",
        text: "Please fill in the red text fields.",
      });
    } else {
      const validItems = items.filter(
        (item) =>
          item.productName &&
          item.productName.value &&
          item.quantity &&
          !isNaN(parseFloat(item.quantity)) &&
          parseFloat(item.quantity) > 0,
      );

      if (validItems.length === 0) {
        const wrapper = document.createElement("div");
        wrapper.className = "center-swal-text";
        wrapper.innerHTML =
          "Please add at least one item with a quantity greater than zero.";
        swal({
          icon: "error",
          title: "No Valid Items",
          content: wrapper,
        });
        return;
      }

      // Validation for empty moisture on valid items
      const itemsWithEmptyMoisture = validItems
        .map((item) => ({ item, rowNumber: items.indexOf(item) + 1 }))
        .filter(
          ({ item }) =>
            item.moisture === "" ||
            item.moisture === null ||
            item.moisture === undefined,
        );

      if (itemsWithEmptyMoisture.length > 0) {
        const rowLabels = itemsWithEmptyMoisture
          .map(
            ({ item, rowNumber }) =>
              `Row ${rowNumber} - ${item.productName?.label || "Unknown Product"}`,
          )
          .join("\n");
        swal({
          icon: "error",
          title: "Missing Moisture",
          text: `Please fill in the Moisture field for the following item(s) before saving.\nEnter 0 if there is no moisture deduction.\n\n${rowLabels}`,
        });
        return;
      }

      const hasNonZeroUnitPrice = validItems.some((item) => {
        const unitPrice =
          parseFloat(String(item.unitPrice).replace(/,/g, "")) || 0;
        return unitPrice > 0;
      });

      if (hasNonZeroUnitPrice && totalAmount <= 0) {
        const wrapper = document.createElement("div");
        wrapper.className = "center-swal-text";
        wrapper.innerHTML =
          "The Total Amount must be greater than zero. Please check your input.";
        swal({
          icon: "error",
          title: "Invalid Amount",
          content: wrapper,
        });
        return;
      }

      // Validation for negative Total Amount
      if (totalAmount < 0) {
        swal({
          icon: "error",
          title: "Invalid Total Amount",
          text: "The Total Amount cannot be less than 0",
        });
        return;
      }

      swal({
        title: "Update this invoice?",
        text: "Please confirm to update this invoice",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((confirmed) => {
        if (confirmed) {
          const updatedItems = items.map((item, index) => ({
            ...item,
            quantity: inputQuantities[index] || item.quantity,
          }));

          const itemsToSend = items
            .filter(
              (item) =>
                item.productName &&
                item.productName.value &&
                parseFloat(String(item.quantity).replace(/,/g, "")) > 0,
            )
            .map((item, index) => {
              const finalQty =
                parseFloat(String(item.quantity).replace(/,/g, "")) || 0;

              return {
                stock_management_id:
                  item.stock_management_id ||
                  item.stockDetails?.[0]?.stock_management_id ||
                  "",
                product_id: item.productName?.value,
                quantity: finalQty,
                moisture:
                  parseFloat(String(item.moisture).replace(/,/g, "")) || 0,
                netWeight:
                  parseFloat(String(item.netWeight).replace(/,/g, "")) || 0,
                unitPrice:
                  parseFloat(String(item.unitPrice).replace(/,/g, "")) || 0,
                discount:
                  parseFloat(String(item.discount).replace(/,/g, "")) || 0,
                discountType: item.discountType || "percentage",
                subtotal: item.subtotal || 0,
                averagePrice: item.averagePrice || 0,
                salesProfit: item.sales_profit || 0,
                order_index: index + 1,
              };
            });

          const payload = {
            items: itemsToSend,
          };

          console.log(itemsToSend);
          const shipAmountFormat = parseNumber(shipmentFee) || 0;

          axios
            .post(`${BASE_URL}/invoice/update`, {
              transactionId,
              clientTransactionId,
              selectedCustomer: selectedCustomer?.value,
              selectedCurrency,
              selectedMethod,
              selectedDueDate,
              selectedInvoiceDate,
              selectedWarehouse,
              inputPaymentTerms,
              remarks,
              drNumber,
              poNumber,
              containerNumber,
              pier,
              selectedDestination,
              totalAmount: totalAmount.toFixed(2),
              transactionDiscount: displayDiscount,
              transactionDiscountType: modalDiscountType,
              shippingFee: displayShippingFee,
              totalItemDiscount,
              payload,
              currencyRate: editableCurrencyRate,
              id,
              userLoggedID,
              selectedSubject3,
              shipAmountFormat,
              amount,
              qty,
              vatPercent,
              tax_id: selectedTaxId || null,
              tax_rate: parseFloat(selectedTaxRate || 0),
              weighingFee: displayWeighingFee || 0,
              otherFee: displayOtherFee || 0,
              otherFees: JSON.stringify(otherFees),
              isSpecialTax: isSpecialTax,
            })
            .then((res) => {
              console.log("API Response:", res); // <-- Log response
              if (res.status === 200) {
                swal({
                  title: "Success",
                  text: "Invoice updated successfully",
                  icon: "success",
                  buttons: false,
                  timer: 2000,
                  dangerMode: true,
                }).then(() => {
                  // Refetch the data and exit edit mode
                  fetchSpecificInvoice();
                  setEdit(false);
                });
              } else if (res.status === 201) {
                swal({
                  title: "Opppss!",
                  text: "Cutoff already posted for this invoice date",
                  icon: "warning",
                  buttons: false,
                  timer: 2000,
                  dangerMode: true,
                });
              } else if (res.status === 203) {
                swal({
                  title: "Opppss!",
                  text: "This invoice is already included in a collection and can no longer be edited.",
                  icon: "warning",
                  buttons: false,
                  timer: 2500,
                  dangerMode: true,
                }).then(() => {
                  fetchSpecificInvoice();
                });
              } else {
                swal({
                  title: "Something Went Wrong",
                  text:
                    res.data.message ||
                    "Please contact your support immediately",
                  icon: "error",
                  buttons: false,
                  timer: 2000,
                  dangerMode: true,
                });
              }
            })
            .catch((err) => {
              console.error("API Error:", err); // <-- Log error

              if (err.response && err.response.status === 409) {
                if (invoiceStatus === "Pending") {
                  swal({
                    icon: "error",
                    title: "Transaction ID Conflict",
                    text: "The transaction ID you entered already exists in the system. Please use a unique identifier.",
                  });
                  return;
                }
              }

              if (err.response && err.response.status === 422) {
                swal({
                  icon: "error",
                  title: "Insufficient Stock",
                  text:
                    err.response.data.message ||
                    "Insufficient stock to cover the updated quantity.",
                });
                return;
              }

              // imbalance checker / invalid cutoff
              if (err.response && err.response.status === 401) {
                swal({
                  icon: "error",
                  title: err.response.data.title,
                  text: err.response.data.message,
                });
                return;
              }

              swal({
                title: "Something Went Wrong",
                text: "Server error, please contact support",
                icon: "error",
                buttons: false,
                timer: 2000,
                dangerMode: true,
              });
            });
        }
      });
    }
    // setValidated(true);
  };

  const invoiceApproveReject = async (e, action) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      swal({
        icon: "error",
        title: "Fields are required",
        text: "Please fill in the red text fields.",
      });
    } else {
      let actualStatus;
      let promptTitle = "";
      let promptText = "";

      if (action === "approve") {
        actualStatus = totalAmount === 0 ? "Collected" : "Approved";
        promptTitle = "Approve this invoice?";
        promptText =
          totalAmount === 0
            ? "Since the total amount is 0.00, this invoice will automatically be marked as 'Collected'."
            : "Are you sure you want to approve this invoice?";
      } else {
        actualStatus = "Rejected";
        promptTitle = "Reject this invoice?";
        promptText =
          "Are you sure you want to reject this invoice? This action cannot be undone.";
      }

      swal({
        title: promptTitle,
        text: promptText,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((confirmed) => {
        // prettier-ignore
        // For sales journal
        const {currency, totalQuantity, averageUnitPrice} = (() => {
        const currency = currencyData.find((c) => c.id === selectedCurrency);
        const totalQuantity = items.reduce((acc, value) => acc + parseNumber(value.netWeight), 0)
        const totalUnitPrice = items.reduce((acc, value) => acc + parseNumber(value.unitPrice), 0)
        const averageUnitPrice = totalUnitPrice / items?.length

        return {currency, totalQuantity, averageUnitPrice}
      })()

        if (confirmed) {
          if (action === "approve") setIsApproving(true);
          axios
            .post(`${BASE_URL}/invoice/approveRejectInvoice`, {
              id,
              status: actualStatus, // Use the determined status
              selectedInvoiceDate,
              selectedWarehouse,
              userLoggedID,
              shipmentFee,
              items,
              transactionId,
              salesJournal: {
                customerId: selectedCustomer?.value,
                date: selectedInvoiceDate,
                totalAmount,
                totalQuantity,
                averageUnitPrice,
                paymentType: "Debit",
                currencyName: currency.currency_name,
                // currencyRate: currency.currency_rate,
                currencyRate: currencyRate,
              },
            })
            .then((res) => {
              if (action === "approve") setIsApproving(false);
              if (res.status === 200) {
                let successMessage = "";
                if (actualStatus === "Collected") {
                  successMessage =
                    "Sales invoice has been approved and automatically marked as Collected.";
                } else if (actualStatus === "Approved") {
                  successMessage =
                    "Sales invoice has been approved successfully.";
                } else {
                  successMessage = "Sales invoice has been rejected.";
                }

                swal({
                  title: "Success",
                  text: successMessage,
                  icon: "success",
                  buttons: false,
                  timer: 2000,
                  dangerMode: true,
                }).then(() => {
                  fetchSpecificInvoice();
                });
              } else if (res.status === 202) {
                const { invoiceDate, CutoffName, status } = res.data;
                let invoiceStatus;
                if (status === "Approved" || status === "Collected") {
                  invoiceStatus = "Approval";
                } else {
                  invoiceStatus = "Rejection";
                }
                swal({
                  title: `${invoiceStatus} Declined`,
                  text: `Invoice cannot be ${status} as its invoice date (${invoiceDate}) falls within the posted cutoff period named "${CutoffName}".`,
                  icon: "warning",
                  button: "OK",
                });
              }
            })
            .catch((error) => {
              if (action === "approve") setIsApproving(false);
              if (error.response) {
                if (error.response.status === 404) {
                  swal({
                    icon: "warning",
                    title: "Cutoff Not Found",
                    text:
                      error.response.data.message ||
                      "No cutoff exists for this date.",
                  });
                } else if (error.response.status === 400) {
                  swal({
                    icon: "error",
                    title: "Approval/Reject Failed",
                    text:
                      error.response.data.message || "Please check your input.",
                  });
                } else if (
                  error.response.status === 422 &&
                  error.response.data.hasDeficit
                ) {
                  const deficitItems = error.response.data.deficitItems || [];

                  showDeficitAlert(deficitItems, "invoice");
                } else if (error.response.status === 401) {
                  swal({
                    icon: "error",
                    // title: "Please contact your support",
                    title: error.response.data.title,
                    text: error.response.data.message,
                  }); // test 1
                } else {
                  swal({
                    icon: "error",
                    title: "Something Went Wrong",
                    text: "Please contact your support immediately.",
                  });
                }
              } else {
                console.error("Error", error.message);
                swal({
                  icon: "error",
                  title: "Network Error",
                  text: "Please check your internet connection.",
                });
              }
            });
        }
      });
    }
    setValidated(true);
  };

  const isTableDisabled =
    invoiceStatus === "Rejected" ||
    (invoiceStatus === "Approved" &&
      !(edit && authrztn.includes("Invoices-PostApprovalEdit")));

  // Replaced by warnIfNoCutoff (utils/cutoffDateValidation)
  // const dateValidation = async (selectedDate, clearField, dateLabel) => {
  //   try {
  //     const res = await axios.get(`${BASE_URL}/cutoff/dateValidation`, {
  //       params: {
  //         date: selectedDate,
  //       },
  //     });
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const handleChangeCurrency = (value) => {
    const curr = currencyData.find((data) => String(data.id) === String(value));
    if (curr) {
      setSelectedCurrency(curr.id);
      const newRate = parseFloat(curr.currency_rate) || 1;
      setCurrencyRate(newRate);
      setEditableCurrencyRate(newRate);

      // Reconvert unit prices + subtotals; averagePrice is the PHP base in update form
      const updatedItems = items.map((item) => {
        if (!item.productName || !item.productName.value) return item;
        const phpPrice =
          parseFloat(String(item.averagePrice).replace(/,/g, "")) || 0;
        if (phpPrice === 0) return item;

        const convertedPrice = phpPrice / newRate;
        const netWeight =
          parseFloat(String(item.netWeight).replace(/,/g, "")) || 0;
        const discount =
          parseFloat(String(item.discount).replace(/,/g, "")) || 0;

        let subtotal = netWeight * convertedPrice;
        const effectiveDiscount =
          item.discountType === "percentage"
            ? (discount / 100) * subtotal
            : discount;
        subtotal -= effectiveDiscount;

        return {
          ...item,
          unitPrice: convertedPrice,
          subtotal,
        };
      });

      setItems(updatedItems);
      calculateTotals(
        updatedItems,
        false,
        vatPercent,
        selectedTaxRate,
        displayWeighingFee,
        displayOtherFee,
        otherFees,
        displayDiscount,
        modalDiscountType,
      );
    }
  };
  const openPDFPreview = () => {
    setPrint(true);
  };

  const customerOptions = useMemo(
    () =>
      customerData.map((data) => ({
        value: data.customer_id,
        label: getCustomerLabel(data),
      })),
    [customerData],
  );

  // For Item list input select width
  const selectProductWidth = Math.max(
    ...items.map((item) => item.productName.label?.length || 0),
  );

  // The product Select's menu is portalled to document.body
  // (menuPortalTarget), where react-select gives its wrapper z-index: 1.
  // The sticky header row (thead/th) is z-index: 2, so it painted over the
  // menu and hid its last options whenever the menu opened across the
  // header. Lift the portal above the header row. Layered on top of
  // selectCustomStyles so the shared style file and the customer select
  // are untouched.
  const withMenuAboveStickyHeader = (baseStyles) => ({
    ...baseStyles,
    menuPortal: (provided, state) => ({
      ...(baseStyles.menuPortal
        ? baseStyles.menuPortal(provided, state)
        : provided),
      zIndex: 9999,
    }),
  });

  const getPriceIndicator = (unitPrice, averagePrice) => {
    if (!unitPrice || !averagePrice) return null;

    const unitPriceNum = parseFloat(
      parseFloat(String(unitPrice).replace(/,/g, "") || 0).toFixed(4),
    );
    const avgPriceNum = parseFloat(
      parseFloat(String(averagePrice).replace(/,/g, "") || 0).toFixed(4),
    );

    if (unitPriceNum === avgPriceNum) {
      return { label: "Same Price", color: "text-success", srp: avgPriceNum };
    } else if (unitPriceNum > avgPriceNum) {
      return {
        label: "Above SRP",
        color: "text-danger",
        srp: avgPriceNum,
        symbol: currencySymbol,
      };
    } else {
      return {
        label: "Below SRP",
        color: "text-info",
        srp: avgPriceNum,
        symbol: currencySymbol,
      };
    }
  };

  useEffect(() => {
    if (currencyRate !== undefined && currencyRate !== null) {
      setEditableCurrencyRate(currencyRate);
    }
  }, [currencyRate]);

  const handleEditableCurrencyRateChange = (e) => {
    let inputValue = e.target.value.replace(/[^0-9.]/g, "");
    if ((inputValue.match(/\./g) || []).length > 1) return;
    let [integerPart, decimalPart] = inputValue.split(".");
    if (integerPart) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    let formattedValue =
      decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

    setEditableCurrencyRate(formattedValue);
    setCurrencyRate(formattedValue);
  };
  const [isTextDrValidationVisible, setIsTextDrValidationVisible] =
    useState(false);
  const handleValidateDR = (e) => {
    const drValue = e.target.value.trim();
    setDrNumber(drValue);
    if (!drValue) return;

    const delayDebounce = setTimeout(() => {
      checkDrNumber(drValue, id)
        .then((res) => {
          if (res.data === false) {
            setIsTextDrValidationVisible(false); //check
          } else {
            setIsTextDrValidationVisible(true); // X
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }, 500); // ⏱️ .5 seconds delay

    return () => clearTimeout(delayDebounce);
  };

  const handleSpecialTax = (e) => {
    const isChecked = e.target.checked;
    setIsSpecialTax(isChecked);

    let newVat = vatPercent;
    let newTaxId = selectedTaxId;
    let newTaxRate = selectedTaxRate;

    if (isChecked) {
      setBackupVatPercent(vatPercent);
      setBackupTaxId(selectedTaxId);
      setBackupTaxRate(selectedTaxRate);

      newVat = 0;
      newTaxId = "";
      newTaxRate = 0;
    } else {
      newVat = backupVatPercent;
      newTaxId = backupTaxId;
      newTaxRate = backupTaxRate;
    }

    setVatPercent(newVat);
    setSelectedTaxId(newTaxId);
    setSelectedTaxRate(newTaxRate);

    calculateTotals(
      items,
      false,
      newVat,
      newTaxRate,
      displayWeighingFee,
      displayOtherFee,
      otherFees,
      displayDiscount,
      modalDiscountType,
      isChecked,
    );
  };

  return (
    <div className="h-100 w-100 border bg-white custom-container">
      <style>{`
        .scroll-fab {
          width: 46px;
          height: 46px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.18);
          transition: transform 0.18s ease, box-shadow 0.18s ease;
        }
        .scroll-fab:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
        }
        .scroll-fab:active {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }
        /* Bootstrap gives a focused/validated .input-group field (Moisture,
           Discount) a z-index up to 5, which is higher than the sticky
           column headers' z-index of 2 above — so on scroll that field
           painted on top of the "Moisture" header text instead of staying
           behind it. Giving each body cell its own stacking context (with
           a z-index lower than the header) contains that escalation inside
           the cell so it can no longer escape above the sticky header row. */
        .item-list-table tbody td {
          position: relative;
          z-index: 0;
        }
      `}</style>
      {/* Form noValidate validated={validated} onSubmit={updateInvoice} */}
      <Form onSubmit={updateInvoice}>
        <div className="w-100 p-2 d-flex flex-row justify-content-between">
          <div className="d-flex flex-column title-custom">
            <span className="fs-3">
              <button
                type="button"
                className="border-0 bg-transparent d-inline-block"
                onClick={() => {
                  if (edit) {
                    swal({
                      icon: "warning",
                      title: "Discard Unsaved Changes?",
                      text: "Going back now will remove any changes you've made.",
                      buttons: true,
                      dangerMode: true,
                    }).then((confirm) => {
                      if (confirm) navigate("../sales/invoices");
                    });
                    return;
                  }
                  navigate("../sales/invoices");
                }}
              >
                <i className="fa-solid fa-arrow-left text-dark"></i>
              </button>
              SALES INVOICE OVERVIEW
            </span>
            <p className="fs-6">
              Status:{" "}
              <span
                style={{
                  color:
                    invoiceStatus === "Approved" || invoiceStatus === "Paid"
                      ? "green"
                      : invoiceStatus === "Pending"
                        ? "orange"
                        : "red",
                  textTransform: "uppercase",
                }}
              >
                {invoiceStatus}
              </span>
            </p>
          </div>
          <div className="d-flex gap-2">
            {(invoiceStatus === "Approved" || invoiceStatus === "Collected") &&
              authrztn.includes("Invoices-Print") && (
                <div>
                  <button
                    className="btn btn-outline-danger d-inline-flex align-items-center gap-2"
                    type="button"
                    onClick={openPDFPreview}
                  >
                    <i className="fa-solid fa-file-pdf"></i>
                    Preview PDF
                  </button>
                </div>
              )}
          </div>
        </div>
        <div className="container-fluid mt-3">
          <div className="row mx-auto">
            <div className="d-none col-sm mb-3">
              <span>Transaction ID</span>
              <Form.Control
                type="text"
                name=""
                id=""
                className="form-control custom-form-height"
                readOnly
                value={transactionId}
              />
            </div>
            <div className="col-sm mb-3">
              <span>Transaction ID</span>
              {/* Display only - generated by the server on create */}
              <Form.Control
                type="text"
                name=""
                id=""
                className="form-control custom-form-height"
                value={clientTransactionId}
                readOnly
              />
            </div>
            <div className="col-sm">
              <span>
                Warehouse <span className="text-danger">*</span>
              </span>
              <Form.Select
                name=""
                id=""
                className="form-select custom-form-height"
                required
                onChange={(e) => {
                  const warehouseId = e.target.value;
                  setSelectedWarehouse(warehouseId);
                  fetchDataProduct(warehouseId);
                }}
                value={selectedWarehouse}
                disabled={isTableDisabled || !edit}
              >
                <option value="" selected disabled>
                  Select Warehouse
                </option>
                {warehouseData.map((data, i) => (
                  <option key={i} value={data.warehouse_id}>
                    {`${data.name}`}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>
          <div className="row mx-auto">
            <div className="col-sm mb-3">
              <span>Customer</span>
              <CustomerSelect
                options={customerOptions}
                value={selectedCustomer}
                onChange={(selectedOption) => {
                  setSelectedCustomer(selectedOption);
                  const customer = customerData.find(
                    (data) => data.customer_id === selectedOption.value,
                  );
                  if (customer) {
                    setSelectedDestination(customer.destination || "Local");
                    if (customer.currency_id)
                      handleChangeCurrency(customer.currency_id);
                    const newVat = parseFloat(customer.vat_percent) || 0;
                    setVatPercent(newVat);
                    setSelectedTaxId("");
                    setSelectedTaxRate(0);
                    calculateTotals(
                      items,
                      false,
                      newVat,
                      0,
                      displayWeighingFee,
                      displayOtherFee,
                      otherFees,
                      displayDiscount,
                      modalDiscountType,
                    );
                  }
                }}
                placeholder="Select Customer"
                styles={themeSelectStyles(
                  selectCustomStyles(selectedCustomer, validated, "0.3rem"),
                )}
                isDisabled={isTableDisabled || !edit}
                required
                isSearchable
              />
            </div>

            <div className="col-sm mb-3">
              <span>Payment Method</span>
              <Form.Select
                className="form-select custom-form-height"
                required
                onChange={(e) => setSelectedMethod(e.target.value)}
                value={selectedMethod}
                disabled={isTableDisabled || !edit}
              >
                <option value="" disabled>
                  Select Payment Method
                </option>
                <option value="Cash">Cash</option>
                <option value="Bank">Bank</option>
                <option value="Wallet">Wallet</option>
              </Form.Select>
            </div>
          </div>

          {selectedCustomer && (
            <>
              <div className="row mx-auto">
                <div className="col-sm mb-3">
                  <span>VAT %</span>
                  <Form.Control
                    type="text"
                    inputMode="decimal"
                    min="0"
                    className="form-control custom-form-height"
                    value={vatPercent}
                    disabled={isTableDisabled || !edit || isSpecialTax}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow empty, digits, and at most one decimal point with up to 2 decimal places
                      if (!/^\d*\.?\d{0,2}$/.test(value)) return;
                      const numericValue = parseFloat(value) || 0;
                      // Clamp to 100
                      const clamped = numericValue > 100 ? 100 : numericValue;
                      setVatPercent(numericValue > 100 ? "100" : value);
                      calculateTotals(
                        items,
                        false,
                        clamped,
                        selectedTaxRate,
                        displayWeighingFee,
                        displayOtherFee,
                        otherFees,
                        displayDiscount,
                        modalDiscountType,
                      );
                    }}
                  />
                </div>

                <div className="col-sm mb-3">
                  <span>Withholding Tax</span>
                  <Form.Select
                    className="form-select custom-form-height"
                    value={selectedTaxId}
                    disabled={isTableDisabled || !edit || isSpecialTax}
                    onChange={(e) => {
                      const selected = taxSettings.find(
                        (t) => String(t.id) === String(e.target.value),
                      );
                      const rate = selected ? selected.rate : 0;
                      setSelectedTaxId(e.target.value);
                      setSelectedTaxRate(rate);
                      calculateTotals(
                        items,
                        false,
                        vatPercent,
                        rate,
                        displayWeighingFee,
                        displayOtherFee,
                        otherFees,
                        displayDiscount,
                        modalDiscountType,
                      );
                    }}
                  >
                    <option value="">None</option>
                    {taxSettings.map((tax) => (
                      <option key={tax.id} value={tax.id}>
                        {tax.name} - {tax.rate}%
                      </option>
                    ))}
                  </Form.Select>
                </div>
              </div>
            </>
          )}

          <div className="row mx-auto">
            {" "}
            <div className="col-sm mb-3">
              <span>Invoice Date</span>
              <DatePicker
                selected={
                  selectedInvoiceDate ? new Date(selectedInvoiceDate) : null
                }
                onChange={handleDueInvoiceDate}
                customInput={<TypedDateInput />}
                className={`form-control custom-form-height${
                  validated && !selectedInvoiceDate ? " is-invalid" : ""
                }`}
                wrapperClassName="w-100"
                dateFormat={DATE_PICKER_FORMATS}
                strictParsing
                autoComplete="off"
                required
                disabled={isTableDisabled || !edit}
              />
            </div>
            <div className="col-sm mb-3">
              <span>Due Date</span>
              <DatePicker
                selected={selectedDueDate ? new Date(selectedDueDate) : null}
                onChange={handleDueDateChange}
                customInput={<TypedDateInput />}
                className="form-control custom-form-height"
                wrapperClassName="w-100"
                dateFormat={DATE_PICKER_FORMATS}
                strictParsing
                autoComplete="off"
                disabled={isTableDisabled || !edit}
              />
            </div>
          </div>
          <div className="row mx-auto">
            <div className="col-sm mb-3 d-flex flex-row justify-content-between">
              <div className="w-50 me-3">
                <span>
                  Designation <span className="text-danger">*</span>
                </span>
                <Form.Select
                  name=""
                  id=""
                  className="form-select custom-form-height"
                  required
                  onChange={(e) => setSelectedDestination(e.target.value)}
                  value={selectedDestination}
                  disabled={isTableDisabled || !edit}
                >
                  <option value="" selected disabled>
                    Select Designation
                  </option>
                  <option value="Local">Local</option>
                  <option value="Overseas">Overseas</option>
                </Form.Select>
              </div>
              <div className="w-50">
                <span>
                  Currency <span className="text-danger">*</span>
                </span>
                {selectedCurrency &&
                selectedCurrency !== "11111111-1111-1111-1111-111111111111" ? (
                  <span className="text-muted mb-1">
                    {" "}
                    Current Rate: {currencyRate}
                  </span>
                ) : null}
                <Form.Select
                  name=""
                  id=""
                  className="form-select custom-form-height"
                  required
                  onChange={(e) => handleChangeCurrency(e.target.value)}
                  value={selectedCurrency}
                  disabled={isTableDisabled || !edit}
                >
                  <option value="" selected disabled>
                    Select Currency
                  </option>
                  {currencyData.map((data, i) => (
                    <option key={i} value={data.id}>
                      {data.currency_name} - {currencyList[data.currency_name]}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </div>
            <div className="col-sm mb-3 d-flex flex-row justify-content-between">
              {selectedCurrency &&
              selectedCurrency !== "11111111-1111-1111-1111-111111111111" ? (
                <div className="w-50 me-3 d-none">
                  <>
                    <span>
                      Currency Rate<span className="text-danger">*</span>
                    </span>
                    {edit ? (
                      <Form.Control
                        type="text"
                        name=""
                        id=""
                        className="form-control custom-form-height"
                        required
                        onChange={handleEditableCurrencyRateChange}
                        value={editableCurrencyRate}
                        disabled={isTableDisabled}
                        readOnly
                      />
                    ) : (
                      <Form.Control
                        type="text"
                        name=""
                        id=""
                        className="form-control custom-form-height"
                        value={parseFloat(currencyRate || 1).toLocaleString(
                          "en-US",
                          {
                            minimumFractionDigits: 4,
                            maximumFractionDigits: 4,
                          },
                        )}
                        readOnly
                      />
                    )}
                  </>
                </div>
              ) : null}
              <div
                className={`${
                  selectedCurrency &&
                  selectedCurrency !== "11111111-1111-1111-1111-111111111111"
                    ? "w-50"
                    : "w-100"
                }`}
              >
                <span>Payment Terms</span>
                <Form.Control
                  type="text"
                  name=""
                  id=""
                  className="form-control custom-form-height"
                  // required
                  onChange={(e) => setInputPaymentTerms(e.target.value)}
                  value={inputPaymentTerms}
                  disabled={isTableDisabled || !edit}
                />
              </div>
            </div>
          </div>
          <div className="row mx-auto">
            <div className="col-sm mb-3 d-flex flex-row justify-content-between">
              <div className="w-50 me-3">
                <Form.Label>DR Number</Form.Label>
                <div className="input-group">
                  <span className="input-group-text">
                    <Form.Check
                      checked={drNumberEnabled}
                      disabled={isTableDisabled || !edit}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setDrNumberEnabled(isChecked);

                        if (isChecked) {
                          // If this invoice already had a DR number, restore it
                          if (originalDrNumber) {
                            setDrNumber(originalDrNumber);
                          } else {
                            // Otherwise, it's a new DR number request, so fetch it
                            fetchDrNumberCode();
                          }
                        } else {
                          // Clear the input when unchecked
                          setDrNumber("");
                        }
                      }}
                    />
                  </span>
                  <Form.Control
                    ref={drInputRef}
                    type="text"
                    name="dr-number"
                    id="dr-number"
                    value={drNumber}
                    className="form-control custom-form-height"
                    disabled={!drNumberEnabled || isTableDisabled || !edit}
                    onChange={handleValidateDR}
                  />
                  {drNumber &&
                    (!isTextDrValidationVisible ? (
                      <span className="input-group-text text-success">
                        <i className="fa-solid fa-check"></i>
                      </span>
                    ) : (
                      <span className="input-group-text text-danger">
                        <i className="fa-solid fa-x"></i>
                      </span>
                    ))}
                </div>
              </div>
              <div className="w-50">
                <span>PO Number</span>
                <Form.Control
                  type="text"
                  name=""
                  id=""
                  className="form-control custom-form-height"
                  onChange={(e) => setPoNumber(e.target.value)}
                  value={poNumber}
                  disabled={isTableDisabled || !edit}
                />
              </div>
            </div>
          </div>
          <div className="row mx-auto">
            <div className="col-sm mb-3 d-flex flex-row justify-content-between">
              <div className="w-50 me-3">
                <span>Container Number</span>
                <Form.Control
                  type="text"
                  name=""
                  id=""
                  className="form-control custom-form-height"
                  onChange={(e) => setContainerNumber(e.target.value)}
                  value={containerNumber}
                  disabled={isTableDisabled || !edit}
                />
              </div>
              <div className="w-50">
                <span>Pier</span>
                <Form.Control
                  type="text"
                  name=""
                  id=""
                  className="form-control custom-form-height"
                  onChange={(e) => setPier(e.target.value)}
                  value={pier}
                  disabled={isTableDisabled || !edit}
                />
              </div>
            </div>
          </div>
          <div className="row mx-auto">
            <div className="col-sm mb-3">
              <span>Remarks</span>
              <Form.Control
                as="textarea"
                onChange={(e) => setRemarks(e.target.value)}
                value={remarks}
                rows={3}
                maxLength={250}
                disabled={isTableDisabled || !edit}
              />
            </div>
            <div className="col-sm mb-3 d-flex flex-row justify-content-between">
              <div className="w-25">
                <span>Amount</span>
                <NumberInDecimals
                  type="text"
                  className="form-control custom-form-height"
                  onChange={(value) => shipmentAmount(value, "amount")}
                  decimals={2}
                  value={amount}
                  disabled={isTableDisabled || !edit}
                  required={selectedSubject3}
                />
              </div>
              <span className="align-self-center mx-2">*</span>
              <div className="w-25">
                <span>Quantity</span>
                <NumberInDecimals
                  type="text"
                  className="form-control custom-form-height"
                  onChange={(value) => shipmentAmount(value, "qty")}
                  value={qty}
                  disabled={isTableDisabled || !edit}
                  required={selectedSubject3}
                />
              </div>
              <span className="align-self-center mx-2">=</span>
              <div className="w-50">
                <span>Shipment Amount</span>
                <Form.Control
                  type="text"
                  className="form-control custom-form-height"
                  value={formatToTwoDecimal(shipmentFee)}
                  disabled={isTableDisabled || !edit}
                  readOnly
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid ">
          <button
            type="button"
            className="btn btn-primary rounded-circle scroll-fab"
            onClick={scrollPageToBottom}
            title="Scroll to Bottom"
            aria-label="Scroll to Bottom"
            style={{
              position: "fixed",
              right: "24px",
              bottom: "24px",
              zIndex: 1030,
            }}
          >
            <i className="fa-solid fa-arrow-down fs-5"></i>
          </button>
          <div className="w-100 d-flex align-items-center mt-3 p-2">
            <h5>Item List</h5>
            <hr className="flex-grow-1 mx-3" />
          </div>

          <div
            className="w-100 mt-2  new-item-custom scrollable-contents"
            style={{ overflowX: "auto" }}
          >
            <table className="table table-bordered table-hover item-list-table">
              <thead
                className="table-light"
                style={{ position: "sticky", top: 0, zIndex: 2 }}
              >
                <tr>
                  <th
                    className="px-4 py-2 text-nowrap invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Product Code
                  </th>
                  <th
                    className="px-4 py-2 text-nowrap invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Product Name
                  </th>
                  <th
                    className="px-4 py-2 text-nowrap invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Remaining
                  </th>
                  <th
                    className="px-4 py-2 text-nowrap invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Unit Price
                  </th>
                  <th
                    className="px-4 py-2 text-nowrap invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Qty
                  </th>
                  <th
                    className="px-4 py-2 text-nowrap invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Moisture
                  </th>
                  <th
                    className="px-4 py-2 text-nowrap invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Net Qty
                  </th>
                  <th
                    className="px-4 py-2 text-nowrap invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Discount
                  </th>
                  <th
                    className="px-4 py-2 text-nowrap invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Subtotal
                  </th>
                  <th
                    className="p-2 invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => {
                  const priceIndicator = getPriceIndicator(
                    unitPriceInputs[index] ?? item.unitPrice,
                    item.averagePrice,
                  );

                  return (
                    <tr key={index}>
                      <td>
                        <input
                          type="text"
                          className="form-control form-control-sm p-2"
                          value={item.productCode}
                          readOnly
                        />
                      </td>
                      <td>
                        <Select
                          options={getFilteredProductData(index).map(
                            (data) => ({
                              value: data.product_id,
                              label: `${data.product_name}${
                                data.stock <= 0 ? " (Out of Stock)" : ""
                              }`,
                              isDisabled: data.stock <= 0,
                            }),
                          )}
                          classNamePrefix="item-list-table-select"
                          value={item.productName}
                          onChange={(selectedOption) =>
                            handleProductChange(
                              index,
                              selectedOption,
                              items,
                              setItems,
                            )
                          }
                          placeholder={`Select Product`}
                          styles={themeSelectStyles(
                            withMenuAboveStickyHeader(
                              selectCustomStyles(
                                item.productName?.value ?? "optional", // ← always truthy
                                validated,
                                "0",
                                selectProductWidth,
                              ),
                            ),
                          )}
                          isDisabled={isTableDisabled || !edit}
                          menuPortalTarget={document.body}
                          // menuPosition="fixed"
                          isSearchable
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control form-control-sm p-2"
                          value={formatToTwoDecimal(item.remaining)}
                          readOnly
                        />
                      </td>
                      <td>
                        <div className="unit-price-wrapper">
                          <input
                            type="text"
                            className="form-control form-control-sm p-2"
                            value={
                              unitPriceInputs[index] !== undefined
                                ? unitPriceInputs[index]
                                : item.unitPrice
                            }
                            placeholder="0"
                            onInput={(e) => {
                              // Strip non-numeric except dot
                              if (
                                e.target.value.startsWith("0") &&
                                e.target.value.length === 2 &&
                                e.target.value[1] !== "."
                              ) {
                                e.target.value = e.target.value.slice(1);
                              }
                              e.target.value = e.target.value.replace(
                                /[^0-9.]/g,
                                "",
                              );
                              // Cap at 4 decimal places
                              const val = e.target.value;
                              const dotIndex = val.indexOf(".");
                              if (
                                dotIndex !== -1 &&
                                val.length - dotIndex > 5
                              ) {
                                e.target.value = val.slice(0, dotIndex + 5);
                              }
                            }}
                            onChange={(e) => {
                              setUnitPriceInputs((prev) => ({
                                ...prev,
                                [index]: e.target.value,
                              }));
                            }}
                            onBlur={(e) => {
                              const raw = e.target.value.replace(
                                /[^0-9.]/g,
                                "",
                              );
                              handleInputQTY(index, "unitPrice", raw);
                              setUnitPriceInputs((prev) => {
                                const next = { ...prev };
                                delete next[index];
                                return next;
                              });
                            }}
                            disabled={isTableDisabled || !edit}
                          />
                          {priceIndicator && (
                            <small
                              className={`price-indicator ${priceIndicator.color}`}
                            >
                              {priceIndicator.label} ({priceIndicator.symbol}
                              {formatToTwoDecimal(priceIndicator.srp)})
                            </small>
                          )}
                        </div>
                      </td>
                      <td>
                        <Form.Control
                          type="text"
                          className="form-control form-control-sm p-2"
                          placeholder="Input QTY"
                          value={inputQuantities[index] ?? "0"}
                          onChange={(e) =>
                            handleInputQTY(index, "quantity", e.target.value)
                          }
                          disabled={isTableDisabled || !edit}
                          isValid={
                            validated &&
                            !!item.productName &&
                            parseFloat(inputQuantities[index]) > 0
                          }
                          isInvalid={
                            validated &&
                            !!item.productName &&
                            parseFloat(inputQuantities[index]) <= 0
                          }
                        />
                      </td>
                      <td>
                        <div className="input-group">
                          <Form.Control
                            type="text"
                            className="form-control form-control-sm p-2"
                            placeholder="Input Moisture"
                            value={item.moisture}
                            onChange={(e) =>
                              handleInputQTY(index, "moisture", e.target.value)
                            }
                            required={
                              !!item.productName && !isTableDisabled && edit
                            }
                            disabled={
                              isTableDisabled || !edit || !item.productName
                            }
                            isValid={validated && !!item.productName}
                          />
                          <span className="input-group-text">%</span>
                        </div>
                      </td>
                      <td>
                        <Form.Control
                          type="text"
                          className="form-control form-control-sm p-2"
                          placeholder="Input Net Qty"
                          value={item.netWeight}
                          onChange={(e) =>
                            handleInputQTY(index, "netWeight", e.target.value)
                          }
                          required={
                            !!item.productName && !isTableDisabled && edit
                          }
                          disabled={
                            isTableDisabled || !edit || !item.productName
                          }
                          isValid={validated && !!item.productName}
                        />
                      </td>
                      <td className="text-center">
                        <div className="input-group mb-2">
                          <Form.Control
                            type="text"
                            className="form-control-sm p-2"
                            id="inlineFormInputGroup"
                            placeholder={
                              item.discountType === "percentage"
                                ? "Discount (%)"
                                : `Discount (${currencySymbol})`
                            }
                            value={item.discount}
                            onChange={(e) =>
                              handleInputQTY(index, "discount", e.target.value)
                            }
                            disabled={isTableDisabled || !edit}
                          />
                          <div className="input-group-prepend">
                            <button
                              className="input-group-text bg-white custom-discount-btn"
                              type="button"
                              onClick={() => handleDiscountButton(index)}
                              disabled={isTableDisabled || !edit}
                            >
                              {item.discountType === "percentage"
                                ? "%"
                                : currencySymbol}
                            </button>
                          </div>
                        </div>
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control form-control-sm p-2"
                          value={formatToTwoDecimal(item.subtotal)}
                          readOnly
                          placeholder="0.00"
                        />
                      </td>
                      <td className="text-center">
                        {index !== 0 && (
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => removeItem(index)}
                            type="button"
                            disabled={isTableDisabled || !edit}
                          >
                            <i className="fa-solid fa-trash-can"></i>
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <button
            type="button"
            className="btn btn-primary rounded-circle scroll-fab"
            onClick={scrollPageToTop}
            title="Scroll to Top"
            aria-label="Scroll to Top"
            style={{
              position: "fixed",
              right: "24px",
              bottom: "82px",
              zIndex: 1030,
            }}
          >
            <i className="fa-solid fa-arrow-up fs-5"></i>
          </button>
          <div className="w-100 d-flex justify-content-end mt-2">
            {(invoiceStatus === "Pending" ||
              (invoiceStatus === "Approved" &&
                authrztn.includes("Invoices-PostApprovalEdit"))) && (
              <button
                className="btn btn-primary btn-sm rounded-pill px-3 d-inline-flex align-items-center gap-2"
                type="button"
                onClick={addNewItem}
                disabled={isTableDisabled || !edit}
              >
                <i className="fa-solid fa-plus"></i>
                New Item
              </button>
            )}
          </div>
        </div>

        <div className="row mx-auto p-2 mt-4 mb-4">
          <div className="col-sm"></div>
          <div className="col-sm border-end">
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Total (QTY)</span>
              <span className="text-secondary">
                {formatToTwoDecimal(totalQuantity)}
              </span>
            </div>
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Total Moisture (QTY)</span>
              <span className="text-danger">{totalMoisture}</span>
            </div>
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Total Net (QTY)</span>
              <span className="text-danger">
                {formatToTwoDecimal(totalNetWeight)}
              </span>
            </div>
          </div>

          <div className="col-sm">
            {/* 1. Total Qty Amount */}
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Total Qty Amount</span>
              <span className="text-secondary">
                {currencySymbol}
                {formatToTwoDecimal(totalWeightedAmount)}
              </span>
            </div>

            {/* 2. Total Amount of Moisture */}
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Total Amount of Moisture</span>
              <span className="text-danger">
                {currencySymbol}
                {formatToTwoDecimal(totalMoistureAmount)}
              </span>
            </div>

            {/* 3. Total Net Qty Amount */}
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Total Net Qty Amount</span>
              <span className="text-danger">
                {currencySymbol}
                {formatToTwoDecimal(totalNetWeightAmount)}
              </span>
            </div>

            <hr className="flex-grow-1 mx-3" />

            {/* 4. Subtotal */}
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Subtotal</span>
              <span className="text-secondary">
                {currencySymbol}
                {formatToTwoDecimal(totalNetWeightAmount - totalItemDiscount)}
              </span>
            </div>

            {/* 5. Discount */}
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Discount (₱)</span>
              <span
                className="text-primary"
                onClick={
                  !isTableDisabled && edit
                    ? handleShowTransactionDiscount
                    : undefined
                }
                style={{
                  cursor: !isTableDisabled && edit ? "pointer" : "not-allowed",
                  color: !isTableDisabled && edit ? "blue" : "gray",
                }}
              >
                {displayDiscount > 0 ? (
                  <>
                    {modalDiscountType === "percentage"
                      ? `${formatToTwoDecimal(displayDiscount)}%`
                      : `${currencySymbol}${formatToTwoDecimal(displayDiscount)}`}
                    <span
                      className="ms-2"
                      style={{
                        color: !isTableDisabled && edit ? "red" : "gray",
                        textDecoration:
                          !isTableDisabled && edit ? "underline" : "none",
                        cursor:
                          !isTableDisabled && edit ? "pointer" : "not-allowed",
                      }}
                      onClick={
                        !isTableDisabled && edit ? handleRemoveDiscount : null
                      }
                    >
                      {!isTableDisabled && edit ? "Remove" : "Disabled"}
                    </span>
                  </>
                ) : (
                  invoiceStatus === "Pending" &&
                  (!isTableDisabled && edit ? "Add" : "Disabled")
                )}
              </span>
            </div>

            {/* 6. Gross Amount */}
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Gross Amount</span>
              <span className="text-secondary">
                {currencySymbol}
                {formatToTwoDecimal(preVatBase)}
              </span>
            </div>

            <hr className="flex-grow-1 mx-3" />

            {/* 7. VAT — green */}
            {selectedCustomer && (
              <div className="w-100 d-flex flex-row justify-content-between p-2">
                <span style={{ color: "#198754" }}>
                  {!isSpecialTax && vatPercent > 0
                    ? `VAT (${vatPercent}%)`
                    : "Non-VAT"}
                </span>
                <span style={{ color: "#198754" }}>
                  {currencySymbol}
                  {!isSpecialTax && vatPercent > 0
                    ? formatToTwoDecimal((vatPercent / 100) * preVatBase)
                    : "0.00"}
                </span>
              </div>
            )}

            {/* 8. Withholding Tax */}
            {selectedCustomer && selectedTaxId && selectedTaxRate > 0 && (
              <div className="w-100 d-flex flex-row justify-content-between p-2">
                <span style={isSpecialTax ? { opacity: 0.5 } : {}}>
                  Withholding Tax ({selectedTaxRate}%)
                </span>
                <span
                  className="text-danger"
                  style={isSpecialTax ? { opacity: 0.5 } : {}}
                >
                  ({currencySymbol}
                  {formatToTwoDecimal(
                    !isSpecialTax ? (selectedTaxRate / 100) * preVatBase : 0,
                  )}
                  )
                </span>
              </div>
            )}

            {selectedCustomer && (
              <div className="w-100 d-flex flex-row justify-content-between p-2 align-items-center">
                <Form.Check
                  type="checkbox"
                  id="special-tax-computation"
                  label={
                    <span
                      title={`E = Gross Amount * 1.12\nL = Gross Amount * 0.12\nI = E * 0.01\nTax (Special Computation) = L - I`}
                      style={{
                        cursor:
                          isTableDisabled || !edit ? "default" : "pointer",
                        userSelect: "none",
                      }}
                    >
                      Tax{" "}
                      <small className="text-muted">
                        (Special Computation)
                      </small>
                    </span>
                  }
                  className="mb-0"
                  style={{
                    cursor: isTableDisabled || !edit ? "default" : "pointer",
                  }}
                  checked={isSpecialTax}
                  onChange={handleSpecialTax}
                  disabled={isTableDisabled || !edit}
                />

                {isSpecialTax && (
                  <span className="text-success">
                    {currencySymbol}
                    {formatToTwoDecimal(preVatBase * 0.1088)}
                  </span>
                )}
              </div>
            )}

            {selectedCustomer && <hr className="flex-grow-1 mx-3" />}

            {/* 9. Weighing Fee (Non-Taxable) */}
            {/* <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>
                Weighing Fee <small className="text-muted">(Non-Taxable)</small>
              </span>
              <span
                style={{
                  cursor: !isTableDisabled && edit ? "pointer" : "not-allowed",
                  color: !isTableDisabled && edit ? "blue" : "gray",
                }}
                onClick={
                  !isTableDisabled && edit ? handleShowWeighingFee : undefined
                }
              >
                {displayWeighingFee > 0 ? (
                  <>
                    {currencySymbol}
                    {formatToTwoDecimal(displayWeighingFee)}
                    <span
                      className="ms-2"
                      style={{
                        color: !isTableDisabled && edit ? "red" : "gray",
                        textDecoration:
                          !isTableDisabled && edit ? "underline" : "none",
                        cursor:
                          !isTableDisabled && edit ? "pointer" : "not-allowed",
                      }}
                      onClick={
                        !isTableDisabled && edit
                          ? handleRemoveWeighingFee
                          : null
                      }
                    >
                      {!isTableDisabled && edit ? "Remove" : "Disabled"}
                    </span>
                  </>
                ) : (
                  invoiceStatus === "Pending" &&
                  (!isTableDisabled && edit ? "Add" : "Disabled")
                )}
              </span>
            </div> */}

            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>
                Weighing Fee <small className="text-muted">(Non-Taxable)</small>
              </span>
              <span className="text-danger">
                {isTableDisabled || !edit ? (
                  <>
                    {currencySymbol}
                    {formatToTwoDecimal(displayWeighingFee)}
                  </>
                ) : (
                  <NumberInDecimals
                    className="form-control form-control-sm py-2 text-danger text-end fs-6 border-bottom input-payable-form"
                    placeholder="0.00"
                    decimals={2}
                    value={inputWeighingFee}
                    onChange={handleWeighingFeeChange}
                    style={{ paddingRight: validated ? "2rem" : "0.5rem" }}
                  />
                )}
              </span>
            </div>

            {/* 10. Other Fee (Non-Taxable) */}
            {/* <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>
                Other Fee <small className="text-muted">(Non-Taxable)</small>
              </span>
              <span
                style={{
                  cursor: !isTableDisabled && edit ? "pointer" : "not-allowed",
                  color: !isTableDisabled && edit ? "blue" : "gray",
                }}
                onClick={
                  !isTableDisabled && edit ? handleShowOtherFee : undefined
                }
              >
                {displayOtherFee > 0 ? (
                  <>
                    {currencySymbol}
                    {formatToTwoDecimal(displayOtherFee)}
                    <span
                      className="ms-2"
                      style={{
                        color: !isTableDisabled && edit ? "red" : "gray",
                        textDecoration:
                          !isTableDisabled && edit ? "underline" : "none",
                        cursor:
                          !isTableDisabled && edit ? "pointer" : "not-allowed",
                      }}
                      onClick={
                        !isTableDisabled && edit ? handleRemoveOtherFee : null
                      }
                    >
                      {!isTableDisabled && edit ? "Remove" : "Disabled"}
                    </span>
                  </>
                ) : (
                  invoiceStatus === "Pending" &&
                  (!isTableDisabled && edit ? "Add" : "Disabled")
                )}
              </span>
            </div> */}

            {/* Named Other Fees (multi-row) — paginated */}
            {(() => {
              const start = otherFeePage * OTHER_FEE_PAGE_SIZE;
              const pageSlice = otherFees.slice(
                start,
                start + OTHER_FEE_PAGE_SIZE,
              );
              const totalPages = Math.ceil(
                otherFees.length / OTHER_FEE_PAGE_SIZE,
              );
              return (
                <>
                  {isTableDisabled || !edit
                    ? pageSlice.map((fee, pageIndex) => {
                        const index = start + pageIndex;
                        return (
                          <div
                            key={index}
                            className="w-100 d-flex flex-row justify-content-between p-2"
                          >
                            <span className="text-muted">
                              {fee.feeName || `Fee ${index + 1}`}
                            </span>
                            <span className="text-danger">
                              {currencySymbol}
                              {formatToTwoDecimal(
                                parseFloat(fee.feeAmount) || 0,
                              )}
                            </span>
                          </div>
                        );
                      })
                    : pageSlice.map((fee, pageIndex) => {
                        const index = start + pageIndex;
                        return (
                          <div
                            key={index}
                            className="w-100 d-flex flex-row justify-content-between p-2"
                          >
                            <Form.Control
                              type="text"
                              size="sm"
                              placeholder="Fee Name"
                              value={fee.feeName}
                              onChange={(e) =>
                                handleFeeChange(
                                  index,
                                  "feeName",
                                  e.target.value,
                                )
                              }
                            />
                            <NumberInDecimals
                              className="form-control form-control-sm text-danger"
                              placeholder="0.00"
                              decimals={2}
                              value={fee.feeAmount}
                              onChange={(val) =>
                                handleFeeChange(index, "feeAmount", val)
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => removeFee(index)}
                            >
                              X
                            </button>
                          </div>
                        );
                      })}
                  {totalPages > 1 && (
                    <div className="w-100 d-flex justify-content-between align-items-center px-2 pb-1">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        disabled={otherFeePage === 0}
                        onClick={() => setOtherFeePage((p) => p - 1)}
                      >
                        ‹ Prev
                      </button>
                      <small className="text-muted">
                        {otherFeePage + 1} / {totalPages}
                      </small>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        disabled={otherFeePage >= totalPages - 1}
                        onClick={() => setOtherFeePage((p) => p + 1)}
                      >
                        Next ›
                      </button>
                    </div>
                  )}
                </>
              );
            })()}

            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>
                Other Fee <small className="text-muted">(Non-Taxable)</small>
              </span>
              {!(isTableDisabled || !edit) && (
                <button
                  type="button"
                  onClick={addNewFee}
                  className="border-0 text-primary bg-white p-0"
                >
                  Add
                </button>
              )}
            </div>

            {/* 11. Total Amount */}
            <div className="w-100 d-flex flex-row justify-content-between p-3 mt-3 total-amount-container align-items-center rounded">
              <span className="text-white">Total Amount</span>
              <span className="text-white">
                {currencySymbol}
                {formatToTwoDecimal(totalAmount)}
              </span>
            </div>
          </div>
        </div>

        {invoiceStatus === "Pending" && !edit && (
          <div>
            <div className="w-100 text-end mb-3 d-flex justify-content-end gap-2">
              {authrztn.includes("Invoices-Edit") && (
                <button
                  className="btn btn-outline-primary w-25"
                  type="button"
                  // disabled={isCutoffPosted}
                  onClick={(e) => {
                    e.preventDefault();
                    setEdit(true);
                  }}
                >
                  Edit
                </button>
              )}
              {authrztn.includes("Invoices-Approve") && (
                <button
                  className="btn btn-outline-danger w-25 d-inline-flex align-items-center justify-content-center gap-2"
                  type="button"
                  onClick={openPDFPreview}
                  disabled={isCutoffPosted || !isCutoffExists}
                >
                  <i className="fa-solid fa-file-pdf"></i>
                  Preview PDF
                </button>
              )}
            </div>
            {authrztn.includes("Invoices-Approve") && (
              <>
                <div className="d-none col-sm mb-2">
                  <button
                    className="btn btn-danger w-100"
                    type="button"
                    onClick={(e) => invoiceApproveReject(e, "reject")}
                    disabled={isCutoffPosted}
                  >
                    Reject
                  </button>
                </div>
                <div className="d-none col-sm">
                  <button
                    className="btn btn-success w-100"
                    type="button"
                    onClick={(e) => invoiceApproveReject(e, "approve")}
                    disabled={isCutoffPosted}
                  >
                    Approve
                  </button>
                </div>

                {(authrztn.includes("Invoices-Edit") ||
                  authrztn.includes("Invoices-Approve")) &&
                  isCutoffPosted && (
                    <div className="w-100 mt-2 text-end">
                      <p className="text-danger">
                        Action is prohibited as the Invoice date has already
                        been posted.
                      </p>
                    </div>
                  )}

                {(authrztn.includes("Invoices-Edit") ||
                  authrztn.includes("Invoices-Approve")) &&
                  !isCutoffExists && (
                    <div className="w-100 mt-2 text-end">
                      <p className="text-danger">
                        Action is prohibited as the Invoice date has not been
                        created.
                      </p>
                    </div>
                  )}
              </>
            )}
          </div>
        )}
        {invoiceStatus === "Approved" &&
          !edit &&
          authrztn.includes("Invoices-PostApprovalEdit") && (
            <>
              <div className="w-100 text-end mb-3 d-flex justify-content-end gap-2">
                <button
                  className="btn btn-outline-primary w-25"
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    setEdit(true);
                  }}
                  disabled={isCutoffPosted || !isCutoffExists || isAdded}
                >
                  Edit
                </button>
              </div>
              {isCutoffPosted && (
                <div
                  className="w-100 mt-2 text-end"
                  style={{ fontSize: "0.8rem" }}
                >
                  <p className="text-danger">
                    Action is prohibited as the Invoice date has already been
                    posted.
                  </p>
                </div>
              )}
              {!isCutoffExists && (
                <div
                  className="w-100 mt-2 text-end"
                  style={{ fontSize: "0.8rem" }}
                >
                  <p className="text-danger">
                    Action is prohibited as the Cutoff date has not been
                    created.
                  </p>
                </div>
              )}
              {isAdded && (
                <div
                  className="w-100 mt-2 text-end"
                  style={{ fontSize: "0.8rem" }}
                >
                  <p className="text-danger">
                    Action is prohibited as this invoice has already been
                    included in a collection.
                  </p>
                </div>
              )}
            </>
          )}
        {((authrztn.includes("Invoices-Edit") && invoiceStatus === "Pending") ||
          (authrztn.includes("Invoices-PostApprovalEdit") &&
            invoiceStatus === "Approved")) && (
          <>
            {edit && (
              <div className="w-100 text-end mb-3 d-flex justify-content-end gap-2">
                <button
                  className="btn btn-secondary w-25"
                  type="button"
                  onClick={() => {
                    swal({
                      icon: "warning",
                      title: "Are you sure?",
                      text: "Your changes will not be saved.",
                      dangerMode: true,
                      buttons: true,
                    }).then((confirm) => {
                      if (confirm) {
                        setBackupVatPercent("");
                        setBackupTaxId("");
                        setBackupTaxRate(0);
                        fetchSpecificInvoice();
                        setEdit(false);
                      }
                    });
                  }}
                >
                  Cancel
                </button>
                <button className="btn btn-primary w-25" type="submit">
                  Update
                </button>
              </div>
            )}
          </>
        )}
      </Form>
      {/* Transaction Discount Modal  */}
      <Modal
        show={transactionDiscountModal}
        onHide={handleCloseTransactionDiscount}
        size="md"
      >
        <Form>
          <Modal.Header closeButton style={{ border: "none" }}>
            <Modal.Title>Discount</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex fs-6">
              <p>
                The discounts will be applied to this transaction automatically
              </p>
            </div>
            <div className="input-group mb-2">
              <Form.Control
                type="text"
                className="form-control-sm p-2"
                id="inlineFormInputGroup"
                value={inputDiscount}
                min={0}
                onChange={handleTransactionDiscount}
                placeholder={
                  modalDiscountType === "percentage"
                    ? "Discount (%)"
                    : `Discount (${currencySymbol})`
                }
              />
              <div className="input-group-prepend">
                <div
                  className="input-group-text bg-white custom-discount-btn"
                  onClick={handleDiscountIcon}
                >
                  {modalDiscountType === "percentage" ? "%" : currencySymbol}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ border: "none" }}>
            <Button
              variant="outline-secondary"
              onClick={handleCloseTransactionDiscount}
            >
              Cancel
            </Button>
            <Button variant="primary" onClick={handleAddDiscount}>
              Add
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Weighing Fee Modal */}
      <Modal show={weighingFeeModal} onHide={handleCloseWeighingFee} size="md">
        <Form>
          <Modal.Header closeButton style={{ border: "none" }}>
            <Modal.Title>Weighing Fee (Non-Taxable)</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="fs-6">
              This fee is non-taxable and will not affect VAT or Withholding Tax
              calculations.
            </p>
            <Form.Control
              type="text"
              className="form-control-sm p-2"
              value={inputWeighingFee}
              placeholder={`Amount (${currencySymbol})`}
              onChange={(e) => {
                let v = e.target.value.replace(/[^0-9.]/g, "");
                if ((v.match(/\./g) || []).length > 1) return;
                setInputWeighingFee(v);
              }}
            />
          </Modal.Body>
          <Modal.Footer style={{ border: "none" }}>
            <Button
              variant="outline-secondary"
              onClick={handleCloseWeighingFee}
            >
              Cancel
            </Button>
            <Button variant="primary" onClick={handleAddWeighingFee}>
              Add
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Other Fee Modal */}
      <Modal show={otherFeeModal} onHide={handleCloseOtherFee} size="md">
        <Form>
          <Modal.Header closeButton style={{ border: "none" }}>
            <Modal.Title>Other Fee (Non-Taxable)</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="fs-6">
              This fee is non-taxable and will not affect VAT or Withholding Tax
              calculations.
            </p>
            <Form.Control
              type="text"
              className="form-control-sm p-2"
              value={inputOtherFee}
              placeholder={`Amount (${currencySymbol})`}
              onChange={(e) => {
                let v = e.target.value.replace(/[^0-9.]/g, "");
                if ((v.match(/\./g) || []).length > 1) return;
                setInputOtherFee(v);
              }}
            />
          </Modal.Body>
          <Modal.Footer style={{ border: "none" }}>
            <Button variant="outline-secondary" onClick={handleCloseOtherFee}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleAddOtherFee}>
              Add
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Shipping Fee modal  */}
      <Modal show={shippingFeeModal} onHide={handleCloseShippingFee} size="md">
        <Form>
          <Modal.Header closeButton style={{ border: "none" }}>
            <Modal.Title>Shipping Fee</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex fs-6">
              <p>
                Shipping fees are calculated based on the total of your order
                and your location
              </p>
            </div>
            <div className="input-group mb-2">
              <Form.Control
                type="text"
                className="form-control-sm p-2"
                id="inlineFormInputGroup"
                placeholder="Amount 0.00"
                value={inputShippingFee}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === ".") {
                    setInputShippingFee((prev) => prev + ".");
                  }
                  let inputValue = value.replace(/[^0-9.]/g, "");
                  if (inputValue) {
                    inputValue = inputValue.replace(
                      /\B(?=(\d{3})+(?!\d))/g,
                      ",",
                    );
                  }

                  const cleanedValue = inputValue.replace(/^0+,|^0+/, ""); // Remove leading zeros and comma

                  setInputShippingFee(cleanedValue);
                }}
                min={0}
              />
            </div>
          </Modal.Body>
          <Modal.Footer style={{ border: "none" }}>
            <Button
              variant="outline-secondary"
              onClick={handleCloseShippingFee}
            >
              Cancel
            </Button>
            <Button variant="primary" onClick={handleAddShippingFee}>
              Add
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* PDF Modal */}
      <Modal show={print} size="xl" onHide={() => setPrint(false)}>
        <div className="position-relative">
          <a
            href={invoicePdf.url || undefined}
            download={`Sales Invoice - ${transactionId}.pdf`}
          >
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip
                  id="tooltip-right"
                  className="me-2"
                  style={{ fontSize: "0.8rem" }}
                >
                  Download as{" "}
                  <strong className="text-danger">
                    "Sales Invoice - {transactionId}.pdf"
                  </strong>
                </Tooltip>
              }
              delay={300}
            >
              <Button
                variant="light"
                className="position-absolute btn btn-light border border-secondary-subtle mb-5 rounded-5"
                style={{ bottom: "-1.8rem", left: "1rem" }}
                disabled={!invoicePdf.url}
              >
                <i class="fa-solid fa-download"></i>
              </Button>
            </OverlayTrigger>
          </a>

          {/* Approve and Reject button inside PDF Modal */}
          <div
            className="position-absolute"
            style={{
              bottom: "1.5rem",
              right: "2.5rem",
            }}
          >
            {authrztn.includes("Invoices-Approve") &&
            invoiceStatus === "Pending" ? (
              <div className="d-flex gap-1">
                <div>
                  <button
                    className="btn btn-sm btn-danger px-3"
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      invoiceApproveReject(e, "reject");
                    }}
                    disabled={isCutoffPosted || !isCutoffExists}
                  >
                    Reject
                  </button>
                </div>
                <div>
                  <button
                    className="btn btn-sm btn-success d-inline-flex align-items-center gap-2"
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      invoiceApproveReject(e, "approve");
                    }}
                    disabled={isCutoffPosted || !isCutoffExists || isApproving}
                  >
                    {isApproving ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        />
                        Approving...
                      </>
                    ) : (
                      "Approve"
                    )}
                  </button>
                </div>
              </div>
            ) : (
              <span
                className={`badge px-3 py-2 fs-6 ${
                  invoiceStatus === "Approved" || invoiceStatus === "Paid"
                    ? "bg-success-subtle text-success border border-success-subtle"
                    : "bg-danger-subtle text-danger border border-danger-subtle"
                }`}
              >
                {invoiceStatus}
              </span>
            )}
          </div>
          <InvoicePDFFrame url={invoicePdf.url} error={invoicePdf.error} />
        </div>
      </Modal>
    </div>
  );
};

export default UpdateInvoice;
